/**
 * Simple Text Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initSimpleText() {
        const blocks = document.querySelectorAll('.simple-text');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] simple-text block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSimpleText);
    } else {
        initSimpleText();
    }
})();